import LenderFundingProgramDetail from './LenderFundingProgramDetail';

export default LenderFundingProgramDetail;
